import { Route } from "react-router-dom";
import { DashboardContainer } from "./Dashboard.container";

export const getDashboardScene = () => (
  <Route index element={<DashboardContainer />} />
);
